module.exports = __webpack_public_path__ + "img/horizontal_3_1_8003.8f2dfa74.png";